import {PolymerElement, html} from '@polymer/polymer';
import {PanelDynamicRegionBehavior} from '../behaviors/panel-dynamic-region-behavior.js';
import {PanelfullregionobjectsSharedStylesHTML} from '../shared-styles/panel-full-region-objects.js';

class KeliPanelFull extends PanelDynamicRegionBehavior(PolymerElement) {
  static get template() {
    return html`
${PanelfullregionobjectsSharedStylesHTML}
<style>
  :host {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  :host(.visible) {
    display: flex;
  }
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-panel-full';
  }

  handleRegionVisibilityChanged(newValue) {
    this.classList.toggle('visible', newValue);
  }
}

customElements.define(KeliPanelFull.is, KeliPanelFull);
export {KeliPanelFull};
